module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchCode),
      expression: "searchCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrar por código"
    },
    domProps: {
      "value": (_vm.searchCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchCode = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrar por nome"
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('UniqueSelect', {
    attrs: {
      "filterText": "Filtrar por tipo",
      "useState": "statusSheets/searchStatus",
      "callback": _vm.getTypeFilters
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "mcl-items",
    staticStyle: {
      "max-height": "500px"
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "center-element"
  }, [_vm._v("Carregando...")]) : _vm._e(), (!_vm.loading && _vm.displayedData.length) ? _c('span', [_c('virtualList', {
    attrs: {
      "size": 25,
      "remain": 20
    }
  }, _vm._l((_vm.displayedData), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "checkbox text-left"
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(item.employee.code))]), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(item.employee.name))]), _c('div', {
      staticClass: "col-md-2"
    }, [(item.status.uuid) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'sheetChecker',
          params: {
            uuid: item.status.uuid
          }
        }
      }
    }, [_vm._v(_vm._s(item.status.name))]) : _vm._e(), (!item.status.uuid) ? _c('span', [_vm._v(_vm._s(item.status.name))]) : _vm._e()], 1)])
  }))], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571d26ab"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatusSheets/StatusSheetsList/StatusSheetsList.vue
// module id = 446
// module chunks = 2